export default "__VITE_ASSET__DbnLP0B___"